import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdditionalInsightsDataService {
  private additionalInsightsSubject = new BehaviorSubject<any>({
    services: null,
    ratings: null
  });
  public additionalInsights$ = this.additionalInsightsSubject.asObservable();

  updateServices(services: any): void {
    const current = this.additionalInsightsSubject.value;
    this.additionalInsightsSubject.next({ ...current, services });
  }

  updateRatings(ratings: any): void {
    const current = this.additionalInsightsSubject.value;
    this.additionalInsightsSubject.next({ ...current, ratings });
  }

  getAdditionalInsights(): any {
    return this.additionalInsightsSubject.value;
  }
}